import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, fetchData, handleAddItem, handleUpdateItem } from "../../utils/data";
import { Policy } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchPolicies = createAsyncThunk("get/Policy", async () => {
        const data = await fetchData(`Policy/getPolicies?lang=${lang}`);
        return data;
});
export const fetchPolicyAdmin = createAsyncThunk("get/PolicyAdmin", async (id:number) => {
        const data = await fetchData(`Policy/getPolicyWithAllData?policyID=${id}`,true);
        return data;
});
export const addPolicy = createAsyncThunk("post/Policy", async (policyData: any) => {
        await handleAddItem(policyData, "Policy/addPolicy", "POST");
        return policyData;
});
export const updatePolicy = createAsyncThunk("PUT/Policy", async ({id, Data }: {id:number, Data: any }) => {
        await handleUpdateItem(Data, `Policy/editPolicy?policyId=${id}`, "PUT");
        return { ...Data };
});
export const deletePolicy = createAsyncThunk("delete/Policy", async (id: number) => {
        await deleteItem(`Policy/deletePolicy?policyID=`,id);
        return id;
});
interface PolicyState {
    policies: Policy[];
    policy: Policy | null;
    loading: boolean;
    error: string;
}

const initialState: PolicyState = {
    policies: [],
    policy: null,
    loading: false,
    error: ""
};

const policySlice = createSlice({
    name: "policySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchPolicies.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchPolicies.fulfilled, (state, action) => {
                state.loading = false;
                state.policies = action.payload;
            })
            // Fetch article data for admin 
            .addCase(fetchPolicyAdmin.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchPolicyAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.policy = action.payload;
            })

            // Add
            .addCase(addPolicy.fulfilled, (state, action) => {
                state.policies.push(action.payload);
            })

            // Update
            .addCase(updatePolicy.fulfilled, (state, action) => {
                state.policies = state.policies.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                );
            })
            // Delete
            .addCase(deletePolicy.fulfilled, (state, action) => {
                state.policies = state.policies.filter((item) => item.id !== action.payload);
            })
    }
});

export default policySlice.reducer;
